import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiCheck } from 'react-icons/fi';
import { EKYC_STEP_PATH, AA_STEP_PATH, THANK_YOU_PATH } from '../../pages/Dashboard/ThankYou/journeyPaths';

// Progress of the post-application journey, shown in the site header on the journey pages only.
// Index 0 ("Application submitted") is already done when the customer reaches the journey.
const STEPS = ['Application submitted', 'Aadhaar e-KYC', 'Account Aggregator', 'Done'];
const STEP_BY_PATH = { [EKYC_STEP_PATH]: 1, [AA_STEP_PATH]: 2, [THANK_YOU_PATH]: 4 };

const NAVY = '#082654';
const TEAL = '#2889a6';
const GREEN = '#10b981';

const STYLES = `
.journey_bar { display: flex; align-items: center; justify-content: center; gap: 8px; min-width: 0; }
/* Mid-size screens: completed steps show only their tick, so the header does not overflow */
@media (max-width: 1280px) { .journey_bar .journey_label.done:not(.current) { display: none; } }
/* Narrow screens: a thin strip under the fixed header; only the current step keeps its label */
@media (max-width: 900px) {
  .journey_bar {
    position: absolute; top: 100%; left: 0; right: 0;
    padding: 10px 16px; background: #ffffff; border-bottom: 1px solid #eef2f6;
    box-shadow: 0 6px 16px rgba(8, 38, 84, 0.05);
  }
  .journey_bar .journey_label { display: none; }
  .journey_bar .journey_label.current { display: inline; }
  /* This style tag only exists on journey pages: make room for the strip */
  .dashboard_content_canvas { padding-top: 160px !important; }
}
`;

function JourneyBar() {
  const { pathname } = useLocation();
  const current = STEP_BY_PATH[pathname.replace(/\/+$/, '')];
  if (current === undefined) return null;

  return (
    <nav className="journey_bar" aria-label="Application progress">
      <style>{STYLES}</style>
      {STEPS.map((label, i) => {
        const done = i < current;
        const active = i === current;
        // On the thank-you page every step is done; keep the last label ("Done") visible everywhere.
        const showAlways = active || (current >= STEPS.length && i === STEPS.length - 1);
        return (
          <React.Fragment key={label}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '7px' }} aria-current={active ? 'step' : undefined}>
              <span style={{
                width: '24px', height: '24px', borderRadius: '50%', flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: done ? GREEN : active ? TEAL : '#e2e8f0',
                color: '#fff', fontWeight: 800, fontSize: '12px',
                boxShadow: active ? '0 0 0 4px rgba(40, 137, 166, 0.18)' : 'none',
              }}>
                {done ? <FiCheck size={14} /> : i}
              </span>
              <span className={`journey_label${done ? ' done' : ''}${showAlways ? ' current' : ''}`} style={{
                fontSize: '13px', fontWeight: 700, whiteSpace: 'nowrap',
                color: done ? '#047857' : active ? NAVY : '#94a3b8',
              }}>
                {label}
              </span>
            </span>
            {i < STEPS.length - 1 && (
              <span style={{ width: '26px', height: '2px', borderRadius: '2px', flexShrink: 0, background: i < current ? GREEN : '#e2e8f0' }} />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export default JourneyBar;
